import { LayoutAdminCafe, LayoutUserCafe } from "../../../layout/layout_cafe";
import { State } from "../../../reducer";
import MenuList from "./menu.list";
import { useSelector } from "react-redux";

function MenuCafe() {
  const user = useSelector((state: State) => state.user);

  return (
    <div>
      {user?.role === "admin" ? (
        <div>
          <LayoutAdminCafe>
            <MenuList />
          </LayoutAdminCafe>
        </div>
      ) : (
        <div>
          <LayoutUserCafe>
            <div>
              <MenuList />
            </div>
          </LayoutUserCafe>
        </div>
      )}
    </div>
  );
}
export default MenuCafe;
